import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/company-logo.png" alt="บริษัท ไทย วายเอสวาย เทรดดิ้ง จำกัด" className="footer-logo-img" style={{maxHeight: '60px'}} />
            </div>
            <h3>บริษัท ไทย วายเอสวาย เทรดดิ้ง จำกัด</h3>
            <p>THAI YSY TRADING CO., LTD.</p>
            <p>ประกอบกิจการผลิต นำเข้า ส่งออก จัดจำหน่าย ตัวแทนจำหน่ายสินค้าอิเล็กทรอนิกส์ หูฟังบลูทูธ ลำโพงบลูทูธ</p>
          </div>

          <div className="footer-section">
            <h4>เมนูลัด</h4>
            <ul>
              <li><a href="/">หน้าแรก</a></li>
              <li><a href="/products">สินค้า</a></li>
              <li><a href="/about">เกี่ยวกับเรา</a></li>
              <li><a href="/contact">ติดต่อ</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>นโยบายและเงื่อนไข</h4>
            <ul>
              <li><a href="/privacy-policy">นโยบายความเป็นส่วนตัว</a></li>
              <li><a href="/terms-of-service">เงื่อนไขการให้บริการ</a></li>
              <li><a href="/return-policy">นโยบายการคืนสินค้า</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>สินค้าของเรา</h4>
            <ul>
              <li>โน้ตบุค</li>
              <li>อุปกรณ์คอมพิวเตอร์</li>
              <li>เครื่องเสียง</li>
              <li>หูฟังบลูทูธ</li>
              <li>ลำโพงบลูทูธ</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>ติดต่อเรา</h4>
            <div className="contact-info">
              <p>📍 32/38 หมู่บ้าน มัณฑนา บางนา วงแหวน</p>
              <p>📍 ถนนรามคำแหง 2 แขวงดอกไม้</p>
              <p>📍 เขตประเวศ กรุงเทพมหานคร 10250</p>
              <p>📞 026-624-7778</p>
              <p>📧 info@thaiysytrading.com</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} บริษัท ไทย วายเอสวาย เทรดดิ้ง จำกัด. สงวนลิขสิทธิ์</p>
            <p>เลขทะเบียน: 0105566223035 | ทุนจดทะเบียน: 4,000,000 บาท</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;